import { render, staticRenderFns } from "./concepts-modal-basic-form.vue?vue&type=template&id=4d13e46d&"
import script from "./concepts-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./concepts-modal-basic-form.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports